<template>
  <!-- TODO: 增加支持富文本：字体、颜色、大小等 -->
  <!-- TODO: webrtc 屏幕共享 -->
  <div id="bd-input">
    <div id="bd-toolbar">
      <el-tooltip :content="emojiTip" placement="top">
        <!-- <li id='bd-emoji' class='iconfont icon-emoji' @click="switchEmoji"></li> -->
        <li
          v-popover:popoverEmoticon
          id="bd-emoji"
          class="iconfont icon-emoji"
        ></li>
      </el-tooltip>
      <!-- 表情 -->
      <!-- <transition name="showbox">
        <div class="bd-emoji-box" v-show="showEmoji">
          <li v-for="item in emojis" :key="item.file">
            <img
              :src="emotionUrl(item.file)"
              :data="item.title"
              @click="emotionClicked(item.title)"
            />
          </li>
        </div>
      </transition> -->
      <!-- 匹配关键词高亮显示 -->
      <transition name="showbox">
        <div class="bd-input-tip" v-show="showInputTip">
          <ul>
            <li
              v-for="tip in inputTips"
              :key="tip.name"
              @click="inputTipClicked(tip)"
            >
              {{ tip.name }}({{ tip.content }})
            </li>
          </ul>
        </div>
      </transition>
      <!-- 消息预知：对方正在输入... -->
      <transition name="showbox">
        <div class="bd-input-tip" v-show="inputTipVisible">
          {{ previewContent }}
        </div>
      </transition>
      <!-- 包含敏感词提示 -->
      <transition name="showbox">
        <div class="bd-input-tip" v-show="showTabooTip">
          <ul>
            {{
              $t("containsTaboo")
            }}：
            <li style="color: red;">{{ tabooTip }}</li>
          </ul>
        </div>
      </transition>
      <el-tooltip content="录音" placement="top">
        <li
          id="bd-microphone"
          class="el-icon-microphone"
          @click="showRecorder"
          :disabled="disabled"
        ></li>
      </el-tooltip>
      <el-tooltip :content="pictureTip" placement="top">
        <li
          v-popover:popoverImageManager
          class="bd-upload-image el-icon-picture-outline-round"
          :disabled="disabled"
        ></li>
      </el-tooltip>
      <!-- accept=".mp4,.mp3,.avi,.wmv,.mpg,.mpeg,.mov,.rm,.ram,.swf,.flv" -->
      <el-upload
        id="bd-video"
        :data="upload_data"
        :name="upload_name"
        :action="uploadVideoServerUrl"
        :show-file-list="false"
        :on-success="handleVideoUploadSuccess"
        :before-upload="beforeVideoUpload"
        :disabled="disabled"
        accept="video/*"
      >
        <el-tooltip :content="videoTip" placement="top">
          <li class="iconfont icon-video1" :disabled="disabled"></li>
        </el-tooltip>
      </el-upload>
      <el-upload
        class="bd-upload-file"
        :data="upload_data"
        :name="upload_name"
        :action="uploadFileServerUrl"
        :show-file-list="false"
        :on-success="handleFileUploadSuccess"
        :before-upload="beforeFileUpload"
        :disabled="disabled"
      >
        <el-tooltip :content="fileTip" placement="top">
          <li class="el-icon-folder"></li>
        </el-tooltip>
      </el-upload>
      <form enctype="multipart/form-data" style="display: none" ref="fileFrom">
        <input
          type="file"
          ref="restFile"
          accept="image/*"
          @change="uploadImageChange"
        />
        <input type="file" ref="restFile2" @change="uploadFileChange" />
      </form>
      <el-tooltip :content="inviteRateTip" placement="top">
        <li
          id="bd-rate"
          class="iconfont icon-rate"
          @click="showInviteRate"
          :disabled="disabled"
        ></li>
      </el-tooltip>
      <!-- TODO: qq邮箱截图插件 https://snip.qq.com/install_plugin.html v-if="showCaptureFunction" -->
      <el-tooltip :content="captureTip" placement="top">
        <li
          id="bd-jietu"
          class="iconfont icon-jietu"
          @click="showCaptureDialog"
          :disabled="disabled"
        ></li>
      </el-tooltip>
      <!-- <el-tooltip :content="rtcVideoTip" placement="top">
        <li id='bd-rtcvideo' class='iconfont icon-video' @click="showRtcDialog" :disabled="disabled"></li>
      </el-tooltip> -->
      <!-- <li id='bd-phone' class='iconfont icon-phone' @click="showPhoneDialog" v-if="showAuthority.debug" :disabled="disabled"></li> -->
      <el-tooltip :content="blacklistTip" placement="top">
        <li
          id="bd-block"
          class="iconfont icon-block"
          @click="showBlockDialog"
          :disabled="disabled"
        ></li>
      </el-tooltip>
      <el-tooltip :content="formTip" placement="top">
        <li
          id="bd-form"
          class="iconfont icon-moreclass"
          @click="showFormDialog"
          :disabled="disabled"
        ></li>
      </el-tooltip>
      <!-- TODO: 测试中 -->
      <el-tooltip
        :content="historyTip"
        placement="top"
        v-if="showAuthority.debug"
      >
        <li
          id="bd-history"
          class="el-icon-time"
          @click="showHistoryDialog"
          :disabled="disabled"
        ></li>
      </el-tooltip>
      <el-tooltip :content="richEditTip" placement="top">
        <li
          id="bd-rich"
          class="el-icon-cherry"
          @click="showRichEditDialog"
          :disabled="disabled"
        ></li>
      </el-tooltip>
      <!-- FIXME: currentThread变化之后，消息预知未变化 -->
      <!-- <li id="bd-tip" v-if="inputTipVisible">{{ previewContent }}</li> -->
    </div>
    <!-- TODO: 修改为富文本编辑器 -->
    <div id="bd-inputbox">
      <div style="display: flex; clear: both;">
        <el-input
          id="myInput"
          ref="myInput"
          v-focus
          type="textarea"
          :rows="3"
          :placeholder="inputTip"
          v-model="inputContent"
          @input="onInputChange"
          @keyup.enter.native="onKeyUp"
          debounce="1500"
          maxlength="500"
          show-word-limit
          v-paste="pasteImage"
          v-drag="dragPasteImage"
        >
        </el-input>
        <el-input
          v-if="shouldTranslate"
          type="textarea"
          :rows="3"
          :placeholder="inputTranslateTip"
          v-model="translateContent"
        >
        </el-input>
      </div>
      <div style="width: 100%; margin-top: 5px;">
        <el-checkbox
          style="float: left;"
          v-model="shouldShowInputTips"
          @change="onShowInputTipsChange"
          >{{ this.$t("showInputTip") }}</el-checkbox
        >
        <el-checkbox
          style="float: left;"
          v-model="shouldTranslate"
          @change="onTranslateChange"
          >{{ this.$t("translate") }}</el-checkbox
        >
        <el-dropdown
          v-if="shouldTranslate"
          style="float: left; margin-left: 25px;"
          type="primary"
          split-button
          size="mini"
          @click="handleTranslateClick"
        >
          翻译成英语
          <el-dropdown-menu slot="dropdown">
            <!-- TODO: 添加更多语言，支持高级选项，由用户决定语言列表 -->
            <el-dropdown-item
              @click.native="handleTranslateToLanguageClick('en')"
              >翻译成英语</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="handleTranslateToLanguageClick('zh')"
              >翻译成汉语</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="handleTranslateToLanguageClick('th')"
              >翻译成泰语</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="handleTranslateToLanguageClick('vie')"
              >翻译成越南语</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="handleTranslateToLanguageClick('id')"
              >翻译成印尼语</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="handleTranslateToLanguageClick('may')"
              >翻译成马来语</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown
          type="primary"
          style="float: right; margin-right: 5px; margin-top: -3px;"
          split-button
          size="mini"
          @click="sendTextMessage"
          :disabled="sendButtonDisabled"
        >
          {{ $t("send") }}
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="send">{{
              $t("returnToSend")
            }}</el-dropdown-item>
            <el-dropdown-item command="line">{{
              $t("returnShiftToLine")
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- TODO: 富文本 -->
      <!-- <tinymce v-model="inputContent"></tinymce> -->
      <!--  -->
      <!-- <el-button class="sendbutton" @click="sendTextMessage" :disabled="sendButtonDisabled">{{ $t('send') }}</el-button> -->
      <!-- @command="handleCommand" -->
      <!-- <el-dropdown
        class="sendbutton"
        split-button
        size="small"
        @click="sendTextMessage"
        :disabled="sendButtonDisabled"
      >
        {{ $t("send") }}
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="send">{{
            $t("returnToSend")
          }}</el-dropdown-item>
          <el-dropdown-item command="line">{{
            $t("returnShiftToLine")
          }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
    </div>
    <!-- <editor-bar v-model="editor.info" :isClear="isClear"></editor-bar> -->
    <!-- 拉黑对话框 -->
    <el-dialog
      v-dialogDrag
      :title="blockReasonTitle"
      :visible.sync="blockDialogVisible"
      width="30%"
      center
    >
      <!-- TODO: 添加拉黑时长到日期之后自动取消拉黑，或者永久拉黑 -->
      <el-input
        type="textarea"
        :rows="4"
        :placeholder="blockReasonTip"
        v-model="blockReason"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="blockDialogVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button type="primary" @click="doBlock">{{ $t("block") }}</el-button>
      </span>
    </el-dialog>
    <!-- 发送表单 -->
    <el-dialog
      v-dialogDrag
      :title="formDialogTitle"
      :visible.sync="formDialogVisible"
      width="30%"
      center
    >
      <el-checkbox-group
        v-model="checkedFormItems"
        @change="handleCheckedCitiesChange"
      >
        <el-checkbox v-for="city in formOptions" :label="city" :key="city">{{
          city
        }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="formDialogVisible = false">{{
          $t("cancel")
        }}</el-button>
        <el-button type="primary" @click="sendFormMessage">{{
          $t("send")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 图片查看器 -->
    <MeEditorImageView
      ref="imageViewer"
      v-model="imageViewer.isShow"
      :file="imageViewer.file"
      @confirm="confirmUploadImage"
    />
    <!-- 录音 -->
    <MeEditorRecorder
      v-if="recorder"
      @close="recorder = false"
      @send="sendRecorder"
    />
    <!-- webrtc音频对话 -->
    <MeEditorWebrtcAudio v-if="webrtcAudio" />
    <!-- webrtc视频对话 -->
    <MeEditorWebrtcVideo v-if="webrtcVideo" />
    <el-popover
      ref="popoverEmoticon"
      placement="top-start"
      width="500"
      trigger="click"
      popper-class="no-padding"
      @show="onEmotionShow"
      @hide="onEmotionHide"
    >
      <MeEditorEmoticon ref="editorEmoticon" @selected="selectEmoticon" />
    </el-popover>
    <el-popover
      ref="popoverImageManager"
      placement="top-start"
      width="500"
      trigger="click"
      popper-class="no-padding"
      @show="onImageManagerShow"
      @hide="onImageManagerHide"
    >
      <MeEditorImageManager ref="editorImageManager" @selected="selectImager" />
    </el-popover>
    <el-popover
      ref="popoverFileManager"
      placement="top-start"
      width="500"
      trigger="click"
      popper-class="no-padding"
      @show="onFileManagerShow"
      @hide="onFileManagerHide"
    >
      <MeEditorFileManager ref="editorFileManager" @selected="selectFiler" />
    </el-popover>
    <!-- 代码块编辑器 -->
    <!--<TalkCodeBlock
      v-if="codeBlock.isShow"
      :edit-mode="codeBlock.editMode"
      @close="codeBlock.isShow = false"
      @confirm="confirmCodeBlock"
    />-->
    <!-- 文件上传管理器 -->
    <!--<MeEditorFileManage ref="filesManager" v-model="filesManager.isShow" />-->
    <!-- 投票 -->
    <!--<MeEditorVote
      v-if="vote.isShow"
      @close="
        () => {
          this.vote.isShow = false
        }
      "
    />-->
    <!-- 富文本编辑发送 -->
    <el-dialog
      v-dialogDrag
      :title="richeditDialogTitle"
      :visible.sync="richEditDialogVisible"
      width="30%"
      center
    >
      <tinymce v-model="inputContent"></tinymce>
      <span slot="footer" class="dialog-footer">
        <el-button @click="richEditDialogVisible = false" size="small">{{
          $t("cancel")
        }}</el-button>
        <el-button type="primary" @click="sendRichTextMessage" size="small">{{
          $t("send")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 消息管理器 -->
    <transition name="el-fade-in-linear">
      <TalkSearchRecord
        v-if="findChatRecord"
        :params="{
          talk_type: params.talk_type,
          receiver_id: params.receiver_id,
          title: params.nickname,
        }"
        @close="findChatRecord = false"
      />
    </transition>
    <!-- //in template section，https://www.npmjs.com/package/emoji-vue -->
    <!-- <VueEmoji ref="emoji" @input="emojiInsert" :value="inputContent" v-show="showEmoji"/> -->
    <!-- emoji picker: https://github.com/DCzajkowski/vue-emoji-picker, 如何自定义按钮显示？ -->
    <!-- <emoji-picker @emoji="emojiInsert" :search="emojiSearch" v-show="showEmoji">
      <button
        class="emoji-invoker"
        slot="emoji-invoker"
        slot-scope="{ events: { click: clickEvent } }"
        @click.stop="clickEvent"
      >
         <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current text-grey">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>
        </svg>
      </button>
      <div slot="emoji-picker" slot-scope="{ emojis, insert, display }">
        <div class="emoji-picker" :style="{ top: display.y + 'px', left: display.x + 'px' }">
          <div class="emoji-picker__search">
            <input type="text" v-model="emojiSearch" v-focus>
          </div>
          <div>
            <div v-for="(emojiGroup, category) in emojis" :key="category">
              <h5>{{ category }}</h5>
              <div class="emojis">
                <span
                  v-for="(emoji, emojiName) in emojiGroup"
                  :key="emojiName"
                  @click="insert(emoji)"
                  :title="emojiName"
                >{{ emoji }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </emoji-picker> -->
  </div>
</template>

<script>
import Vue from "vue";
import MeEditorEmoticon from "../widgets/editor/MeEditorEmoticon";
import MeEditorImageManager from "../widgets/editor/MeEditorImageManager";
import MeEditorFileManager from "../widgets/editor/MeEditorFileManager";
// import MeEditorFileManage from '../widgets/editor/MeEditorFileManage'
import MeEditorImageView from "../widgets/editor/MeEditorImageView";
import MeEditorRecorder from "../widgets/editor/MeEditorRecorder";
import MeEditorWebrtcAudio from "../widgets/editor/MeEditorWebrtcAudio";
import MeEditorWebrtcVideo from "../widgets/editor/MeEditorWebrtcVideo";
// import MeEditorVote from './MeEditorVote'
// import MeEditorLocation from './MeEditorLocation'
// import TalkCodeBlock from '@/components/chat/TalkCodeBlock'
import TalkSearchRecord from "../widgets/TalkSearchRecord";
import { getPasteImgs, getDragPasteImg } from "@/util/editor";
// import html2canvas from 'html2canvas'
import { mapActions, mapGetters, mapState } from "vuex";
// import BdMessage from '@/components/dashboard/main/chat/children/BdMessage'
// import * as constants from '@/util/constants'
// import EditorBar from '@/components/dashboard/main/chat/middle/EditorBar'
import bus from "@/util/eventbus";
const constants = require("@/util/constants");
// let util = require("@/util/util");
// https://github.com/DCzajkowski/vue-emoji-picker
// import { EmojiPicker } from 'vue-emoji-picker'
// https://www.npmjs.com/package/emoji-vue
// import VueEmoji from 'emoji-vue'

export default {
  name: "bd-input",
  data() {
    return {
      show_emoji: false,
      inputContent: "",
      emojiSearch: "",
      translateContent: "",
      inputTipVisible: false,
      previewContent: "",
      localPreviewContent: "",
      blockReason: "垃圾用户",
      drawerDirection: "rtl",
      // 上传图片相关参数
      upload_headers: {
        "X-CSRF-TOKEN": "",
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/json",
        Authorization: "Bearer ",
      },
      upload_data: {
        file_name: "test.png",
        username: "",
        type: "",
        client: "web"
      },
      upload_name: "file",
      // 接收图片服务器地址
      // uploadImageServerUrl: constants.UPLOAD_IMAGE_URL_V2,
      uploadImageServerUrl: constants.UPLOAD_FILE_URL_V3,
      uploadVideoServerUrl: constants.UPLOAD_FILE_URL_V3, // constants.UPLOAD_VIDEO_URL,
      uploadFileServerUrl: constants.UPLOAD_FILE_URL_V3, // constants.UPLOAD_FILE_URL,
      uploadVoiceServerUrl: constants.UPLOAD_FILE_URL_V3, // constants.UPLOAD_VOICE_URL,
      // 上传图片结果集, 格式：{name: '', url: ''}
      uploadedFileList: [],
      //
      searchMessage: "",
      // 拉黑用户
      blockThreadTopic: "",
      isBlockFromAside: false,
      blockDialogVisible: false,
      // 表单
      formDialogVisible: false,
      //
      inputing: this.$t("typing"),
      formOptions: [
        this.$t("name"),
        this.$t("mobile"),
        this.$t("age"),
        this.$t("job"),
        this.$t("email"),
      ],
      checkedFormItems: [this.$t("name"), this.$t("mobile")],
      //
      editor: {
        info: "",
      },
      shouldShowInputTips: true,
      shouldTranslate: false,
      isClear: false,
      //
      // 当前编辑的内容
      editorText: "",
      // 图片查看器相关信息
      imageViewer: {
        isShow: false,
        file: null,
      },
      codeBlock: {
        isShow: false,
        editMode: true,
      },
      filesManager: {
        isShow: false,
      },
      vote: {
        isShow: false,
      },
      // 录音器
      recorder: false,
      // webrtc音频对话
      webrtcAudio: false,
      // webrtc视频对话
      webrtcVideo: false,
      // 富文本dialog
      richEditDialogVisible: false,
      // 对话相关参数
      findChatRecord: false,
      params: {
        type: Object,
        default: function() {
          return {
            // 消息来源（1：好友私信 2:群聊）
            talk_type: 0,
            // 消息接收者ID（好友ID或者群聊ID）
            receiver_id: 0,
            nickname: "",
          };
        },
      },
    };
  },
  // components: { EditorBar },
  components: {
    MeEditorEmoticon,
    MeEditorImageManager,
    MeEditorFileManager,
    // MeEditorFileManage,
    MeEditorImageView,
    // TalkCodeBlock,
    MeEditorRecorder,
    MeEditorWebrtcAudio,
    MeEditorWebrtcVideo,
    // MeEditorVote,
    // MeEditorLocation,
    TalkSearchRecord,
    // EmojiPicker
    // VueEmoji
  },
  computed: {
    ...mapGetters([
      "userInfo",
      "disabled",
      "connectionStatus",
      "networkConnected",
      "userCurrentThread",
      "showAuthority",
      "allCuws",
      "taboos",
      "userCurrentThreadDraft",
    ]),
    ...mapState(["emojis"]),
    emojiTip() {
      return this.$t("emoji");
    },
    pictureTip() {
      return this.$t("picture");
    },
    fileTip() {
      return this.$t("file");
    },
    fileManagerTip() {
      return this.$t("fileManager");
    },
    inviteRateTip() {
      return this.$t("inviteRate");
    },
    captureTip() {
      return this.$t("captureTip");
    },
    videoTip() {
      return this.$t("video2")
    },
    rtcVideoTip() {
      return this.$t("rtcVideo")
    },
    blacklistTip() {
      return this.$t("block");
    },
    formTip() {
      return this.$t("myform");
    },
    formDialogTitle() {
      return this.$t("myform");
    },
    richeditDialogTitle() {
      return this.$t("richedit");
    },
    historyTip() {
      return this.$t("history");
    },
    richEditTip() {
      return this.$t("richedit");
    },
    inputTip() {
      return this.$t("inputTip");
    },
    inputTranslateTip() {
      return this.$t("inputTranslateTip");
    },
    blockReasonTitle() {
      return this.$t("blockReasonTitle");
    },
    blockReasonTip() {
      return this.$t("blockReasonTip");
    },
    showEmoji() {
      return !this.disabled && this.show_emoji;
    },
    showInputTip() {
      return (
        !this.disabled &&
        this.shouldShowInputTips &&
        this.inputContent.length > 0 &&
        this.inputTips.length > 0
      );
    },
    inputTips() {
      // 判断是否显示输入时联想
      if (!this.shouldShowInputTips) {
        return;
      }
      let tips = [];
      for (let z = 0; z < this.allCuws.length; z++) {
        const cate = this.allCuws[z];
        for (let i = 0; i < cate.cuwChildren.length; i++) {
          const category = cate.cuwChildren[i];
          for (let j = 0; j < category.cuwChildren.length; j++) {
            const cuw = category.cuwChildren[j];
            if (
              this.inputContent.length > 0 &&
              ((cuw.name != null &&
                cuw.name.indexOf(this.inputContent) !== -1) ||
                (cuw.content != null &&
                  cuw.content.indexOf(this.inputContent) !== -1))
            ) {
              tips.push({
                name: cuw.name,
                content: cuw.content,
                type: cuw.type,
              });
              // 最多返回6条
              if (tips.length > 5) {
                return tips;
              }
            }
          }
        }
      }
      return tips;
    },
    showTabooTip() {
      // 是否显示敏感词提示
      return this.tabooTip.length > 0;
    },
    tabooTip() {
      // 过滤敏感词
      let tip = "";
      for (let i = 0; i < this.taboos.length; i++) {
        let element = this.taboos[i];
        // console.log('element:', element.content)
        if (
          this.inputContent.length > 0 &&
          this.inputContent.indexOf(element.content) !== -1
        ) {
          return element.content;
        }
      }
      return tip;
    },
    sendButtonDisabled() {
      return this.disabled || this.inputContent.trim().length === 0;
    },
  },
  watch: {
    userCurrentThread(newThread, oldThread) {
      // console.log(newThread.nickname, oldThread.nickname)
      // 保存当前oldThread输入框内容
      let payload = { topic: oldThread.topic, content: this.inputContent };
      this.persistThreadDraft(payload);
      // 显示之前保存newThread的输入框内容
      this.inputContent = this.userCurrentThreadDraft;
    },
    inputContent(newContent, oldContent) {
      if (newContent.length === 0) {
        // 保存当前oldThread输入框内容
        let payload2 = { topic: this.userCurrentThread.topic, content: "" };
        this.persistThreadDraft(payload2);
      }
    },
  },
  methods: {
    ...mapActions("mqtt", ["sendMessageProtobuf", "sendMessageJsonRest", "sendMessageChoiceProtobuf"]),
    ...mapActions([
      "updateCurrentThread",
      "inviteRate",
      "addBlock",
      "getMessages",
      "persistThreadDraft",
      "baiduTranslate",
    ]),
    emojiInsert(emoji) {
      this.inputContent += emoji
    },
    isDisabled() {
      return this.userCurrentThread.id === 0;
    },
    isTypeThread(thread) {
      return thread.type === constants.THREAD_TYPE_WORKGROUP;
    },
    onShowInputTipsChange(value) {
      // console.log('input tips check:', value)
      this.shouldShowInputTips = value;
      Vue.ls.set(constants.SHOW_INPUT_TIPS, value);
    },
    onTranslateChange(value) {
      // console.log('translate check:', value)
      this.shouldTranslate = value;
      Vue.ls.set(constants.SHOULD_TRANSLATE_INPUT, value);
    },
    handleTranslateClick() {
      // console.log("handleTranslateClick");
      // TODO: 根据当前选项翻译
      if (this.inputContent.length > 0) {
        this.doTranslate(this.inputContent, "en");
      } else {
        this.$message.error("翻译内容不能为空");
      }
    },
    handleTranslateToLanguageClick(to) {
      // console.log("handleTranslateToLanguageClick");
      if (this.inputContent.length > 0) {
        this.doTranslate(this.inputContent, to);
      } else {
        this.$message.error("翻译内容不能为空");
      }
    },
    // handleTranslateToEnClick() {
    //   console.log('handleTranslateToEnClick')
    //   if (this.inputContent.length > 0) {
    //     this.doTranslate(this.inputContent, 'en')
    //   } else {
    //     this.$message.error("翻译内容不能为空");
    //   }
    // },
    handleTranslateSuccessResult(response) {
      // console.log("baiduTranslate success:", response);
      if (response.status_code === 200) {
        //
        let dataObject = JSON.parse(response.data);
        let src = dataObject.trans_result[0].src;
        let dst = dataObject.trans_result[0].dst;
        // console.log("baiduTranslate src:", src, " dst:", dst);
        this.translateContent = dst;
      } else {
        this.$message.error(response.data);
      }
      // if (this.loadingInstance) {
      //   this.loadingInstance.close()
      // }
    },
    handleTranslateFailedResult(error) {
      console.log("baiduTranslate error:", error);
      this.$message.error(error);
      // if (this.loadingInstance) {
      //   this.loadingInstance.close()
      // }
    },
    doTranslate(content, to) {
      // console.log("doTranslate");
      // 翻译成：中文
      let payload = {
        mid: "",
        q: content,
        from: "auto",
        to: to,
        successcb: this.handleTranslateSuccessResult,
        failedcb: this.handleTranslateFailedResult,
      };
      this.baiduTranslate(payload);
    },
    onEmotionShow() {
      // console.log('onEmotionShow')
      // this.show_emoji = true;
      bus.$emit(constants.EVENT_BUS_SHOW_EMOTION_POPOVER);
    },
    onEmotionHide() {},
    onImageManagerShow() {
      // console.log('onImageManagerShow')
      bus.$emit(constants.EVENT_BUS_SHOW_IMAGES_POPOVER);
    },
    onImageManagerHide() {},
    onFileManagerShow() {
      // console.log('onFileManagerShow')
      bus.$emit(constants.EVENT_BUS_SHOW_FILES_POPOVER);
    },
    onFileManagerHide() {},
    switchEmoji() {
      if (!this.disabled) {
        this.show_emoji = !this.show_emoji;
      }
    },
    emotionUrl(file) {
      return constants.EMOJI_BASE_URL + file;
    },
    emotionClicked(emotion) {
      this.inputContent += emotion;
      this.show_emoji = false;
    },
    escapeHTML(content) {
      return content
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    },
    // 选中表情包回调事件
    selectEmoticon(data) {
      // console.log('selectEmoticon:', data)
      //
      if (this.disabled) {
        this.$refs.popoverEmoticon.doClose();
        return;
      }
      //
      if (data.type == 1) {
        this.inputContent += data.value;
        // QQ表情
        // let value = this.inputContent
        // let el = this.$refs.myInput
        // let startPos = el.selectionStart
        // let endPos = el.selectionEnd
        // console.log('startPos:' + startPos + ' endPos:' + endPos)
        // let newValue =
        //   value.substring(0, startPos) +
        //   data.value +
        //   value.substring(endPos, value.length)
        // this.inputContent = newValue
        //
        // if (el.setSelectionRange) {
        //   // setTimeout(() => {
        //   //   let index = startPos + data.value.length
        //   //   el.setSelectionRange(index, index)
        //   //   el.focus()
        //   // }, 0)
        // }
      } else {
        // 发送自定义表情图片
        var imageUrl = data.value;
        let payload = {
          type: constants.MESSAGE_TYPE_IMAGE,
          content: imageUrl,
          thread: this.userCurrentThread,
        };
        this.sendMessageProtobuf(payload);
      }
      this.$refs.popoverEmoticon.doClose();
      this.$refs.myInput.focus();
    },
    selectImager(data) {
      this.$refs.popoverImageManager.doClose();
      // 从图片管理器中发送图片
      var imageUrl = data.value;
      let payload = {
        type: constants.MESSAGE_TYPE_IMAGE,
        content: imageUrl,
        thread: this.userCurrentThread,
      };
      this.sendMessageProtobuf(payload);
    },
    selectFiler(data) {},
    inputTipClicked(tip) {
      // 注意：末尾加空格，方便点击之后隐藏tip框
      // TODO: 增加统计CUW使用频次
      if (tip.type === constants.MESSAGE_TYPE_TEXT) {
        this.inputContent = tip.content + " ";
      } else {
        // 发送图片/文件/语音/视频消息
        let payload = {
          type: tip.type,
          content: tip.content,
          thread: this.userCurrentThread,
        };
        this.sendMessageProtobuf(payload);
        this.inputContent = "";
      }
    },
    beforeFileUpload(file) {
      // file.name包含文件后缀
      let timestamp = moment(new Date()).format("YYYYMMDDHHmmss");
      this.upload_data.file_name = timestamp + file.name;
      this.upload_data.username = this.userInfo.username
      this.upload_data.type = constants.UPLOAD_FILE_TYPE_FILE
      // 文件大小控制在10m之内
      const isLt2M = file.size / 1024 / 1024 < 10;
      return isLt2M;
    },
    handleFileUploadSuccess(result, file) {
      // console.log('upload file success result:', result, ' file:', file)
      if (result.status_code === 200) {
        let url = result.data;
        let fileType = file.raw.type
        if (fileType.startsWith("image")) {
          // 图片类型，发送图片消息
          let payload = {
            type: constants.MESSAGE_TYPE_IMAGE,
            content: url,
            thread: this.userCurrentThread,
          };
          this.sendMessageProtobuf(payload);
        } else if (fileType.startsWith("audio")) {
          // 音频
          let payload = {
            type: constants.MESSAGE_TYPE_VOICE,
            content: url,
            thread: this.userCurrentThread,
          };
          this.sendMessageProtobuf(payload);
        } else if (fileType.startsWith("video")) {
          // 视频
          let payload = {
            type: constants.MESSAGE_TYPE_VIDEO,
            content: url,
            thread: this.userCurrentThread,
          };
          this.sendMessageProtobuf(payload);
        } else {
          // 文件类型，发送文件消息
          let payload = {
            type: constants.MESSAGE_TYPE_FILE,
            content: url,
            thread: this.userCurrentThread,
          };
          this.sendMessageProtobuf(payload);
        }
      } else {
        this.$message.error(this.$t("uploadError"));
      }
    },
    beforeVideoUpload(file) {
      // file.name包含文件后缀
      let timestamp = moment(new Date()).format("YYYYMMDDHHmmss");
      this.upload_data.file_name = timestamp + file.name;
      this.upload_data.username = this.userInfo.username
      this.upload_data.type = constants.UPLOAD_FILE_TYPE_VIDEO
      // 文件大小控制在10m之内
      const isLt2M = file.size / 1024 / 1024 < 10;
      return isLt2M;
    },
    handleVideoUploadSuccess(result, file) {
      // console.log('upload file success result:', result, ' file:', file)
      if (result.status_code === 200) {
        let url = result.data;
        // let fileType = file.raw.type
        // 视频
        let payload = {
          type: constants.MESSAGE_TYPE_VIDEO,
          content: url,
          thread: this.userCurrentThread,
        };
        this.sendMessageProtobuf(payload);
      } else {
        this.$message.error(this.$t("uploadError"));
      }
    },
    // 显示录音dialog
    showRecorder() {
      // 判断是否disable状态
      if (this.disabled) {
        return;
      }
      this.recorder = true;
    },
    showWebrtcAudio() {
      // 判断是否disable状态
      if (this.disabled) {
        return;
      }
      this.webrtcAudio = true;
    },
    showWebrtcVideo() {
      // 判断是否disable状态
      if (this.disabled) {
        return;
      }
      this.webrtcVideo = true;
    },
    showFileManager() {
      if (this.disabled) {
        return;
      }
      this.filesManager.isShow = !this.filesManager.isShow;
    },
    // 邀请评价
    // TODO: 收到访客评价之后，禁止重复邀请
    showInviteRate() {
      // 判断是否disable状态
      if (this.disabled) {
        return;
      }
      this.$confirm(this.$t("inviteRateAsure"), this.$t("tip"), {
        confirmButtonText: this.$t("ok"),
        cancelButtonText: this.$t("cancel"),
        type: "info",
      })
        .then(() => {
          // 发送邀请
          let payload = {
            type: constants.MESSAGE_TYPE_NOTIFICATION_INVITE_RATE,
            content: this.$t("inviteRate"),
            thread: this.userCurrentThread,
          };
          this.sendMessageProtobuf(payload);
          //
          this.$message({ type: "success", message: "发送邀请成功!" });
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消发送邀请" });
        });
    },
    handleDrawerClose(done) {
      done();
    },
    // 截图
    showCaptureDialog() {
      // console.log('show capture')
      this.$alert(this.$t("captureNote"), this.$t("capture"), {
        confirmButtonText: this.$t("ok"),
        callback: (action) => {},
      });
      // 浏览器截图: http://html2canvas.hertzen.com/getting-started
      // html2canvas(document.body).then(function (canvas) {
      //   // document.body.appendChild(canvas)
      // })
    },
    // showUploadVideo() {
    //   console.log('showUploadVideo')
    // },
    showRtcDialog() {
      console.log('showRtcDialog')
    },
    // 电话
    showPhoneDialog() {
      console.log("show phone");
    },
    // 黑名单
    showBlockDialog() {
      this.blockThreadTopic = this.userCurrentThread.topic;
      this.isBlockFromAside = false;
      this.blockDialogVisible = true;
    },
    // 拉黑
    doBlock() {
      if (
        this.blockReason.trim().length > 0 &&
        this.blockReason.trim().length < 200
      ) {
        // this.userCurrentThread.uid
        // let uid = this.userCurrentThread.topic.split('/')[1] // 访客uid
        let uid = this.blockThreadTopic.split("/")[1]; // 访客uid
        // console.log('uid:', uid, this.userCurrentThread.topic)
        // 加入黑名单 type: '默认类型',
        let payload = { uid: uid, note: this.blockReason };
        this.addBlock(payload);
        this.blockDialogVisible = false;
        // this.$message.success('拉黑成功')
      } else if (this.blockReason.trim().length > 200) {
        this.$message.error(this.$t("blockReasonTooLong"));
      } else {
        this.$message.error(this.$t("blockReasonNull"));
      }
    },
    showFormDialog() {
      this.formDialogVisible = true;
    },
    showHistoryDialog() {
      this.findChatRecord = true;
    },
    showRichEditDialog() {
      this.richEditDialogVisible = true;
    },
    // 发送表单
    // TODO: 针对公众号或者小程序用户发送URL链接表单
    sendFormMessage() {
      this.formDialogVisible = false;
      // 判断是否disable状态
      if (this.disabled) {
        return;
      }
      // 发送表单消息
      let formContent = JSON.stringify({
        form: this.checkedFormItems,
      });
      // console.log('send form:', formContent)
      let payload = {
        type: constants.MESSAGE_TYPE_NOTIFICATION_FORM_REQUEST,
        content: formContent,
        thread: this.userCurrentThread,
      };
      this.sendMessageProtobuf(payload);
    },
    sendRichTextMessage() {
      // 隐藏富文本对话框
      this.richEditDialogVisible = false;
      // 发送
      this.sendTextMessage();
    },
    handleCheckedCitiesChange(value) {
      console.log("checked:" + value);
      // let checkedCount = value.length;
      // this.checkAll = checkedCount === this.cities.length;
      // this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    // 输入框内容发生变化
    onInputChange(content) {
      // 判断是否disable状态
      if (this.disabled) {
        return;
      }
      this.localPreviewContent = content;
      // 降低消息预知发送频率
      this.delaySendPreviewMessage();
    },
    // 发送消息
    onKeyUp(e) {
      // e.ctrlKey = false, e.shiftKey = false
      // console.log('onKeyUp:', e)
      // 按Enter发送，Shift+Enter换行
      if (e.keyCode === 13 && !e.shiftKey) {
        this.sendTextMessage();
      }
    },
    // 发送按钮下拉
    // handleCommand(command) {
    //   // console.log('click on item ' + command)
    // },
    sendPreviewMessage() {
      // 发送消息预知
      let contentTrim = this.localPreviewContent.trim();
      let payload = {
        type: constants.MESSAGE_TYPE_NOTIFICATION_PREVIEW,
        content: contentTrim,
        thread: this.userCurrentThread,
      };
      this.sendMessageProtobuf(payload);
    },
    sendTextMessage() {
      if (this.disabled) {
        return;
      }
      this.show_emoji = false;
      let content = this.inputContent.trim();
      if (this.shouldTranslate) {
        // 勾选翻译选项之后，发送翻译内容
        content = this.translateContent.trim();
      }
      // content = this.escapeHTML(content)
      if (content.length > 500) {
        this.$notify({
          title: this.$t("tip"),
          message: this.$t("messageTooLong"),
          type: "error",
        });
        return;
      }
      if (content.length > 0) {
        // 通过mqtt长连接发送消息
        let payload = {
          type: constants.MESSAGE_TYPE_TEXT,
          content: content,
          thread: this.userCurrentThread,
        };
        this.sendMessageProtobuf(payload);
        // 提示网络断开
        if (!this.networkConnected) {
          this.$message({ message: "网络异常", type: "warning" });
        }
        // 清空输入框
        this.inputContent = "";
        this.translateContent = "";
      } else {
        if (this.shouldTranslate) {
          this.$message.error("翻译内容不能为空");
        } else {
          this.$message.error("输入内容不能为空");
        }
      }
      // TODO: 判断会话是否已经关闭，如果已经关闭，则提示，且要添加订阅-mqttSubscribe
      if (this.userCurrentThread.closed) {
        this.$message.warning(this.$t("closedSendNotice"));
      }
    },
    //复制粘贴图片回调方法
    pasteImage(e) {
      if (this.disabled) {
        this.$message.error("请先选择会话")
        return
      }
      let files = getPasteImgs(e);
      if (files.length == 0) return;

      this.openImageViewer(files[0]);
    },
    //拖拽上传图片回调方法
    dragPasteImage(e) {
      if (this.disabled) {
        this.$message.error("请先选择会话")
        return
      }
      let files = getDragPasteImg(e);
      if (files.length == 0) return;

      this.openImageViewer(files[0]);
    },
    // 选择图片文件后回调方法
    uploadImageChange(e) {
      console.log(e.target.files[0]);
      this.openImageViewer(e.target.files[0]);
      this.$refs.restFile.value = null;
    },
    // 选择文件回调事件
    uploadFileChange(e) {
      let maxsize = 100 * 1024 * 1024;
      if (e.target.files.length == 0) {
        return false;
      }

      let file = e.target.files[0];
      if (/\.(gif|jpg|jpeg|png|webp|GIF|JPG|PNG|WEBP)$/.test(file.name)) {
        this.openImageViewer(file);
        return;
      }

      if (file.size > maxsize) {
        this.$notify.info({
          title: "消息",
          message: "上传文件不能大于100M",
        });
        return;
      }
      this.filesManager.isShow = true;
      this.$refs.restFile2.value = null;
      this.$refs.filesManager.upload(file);
    },
    // 打开图片查看器
    openImageViewer(file) {
      this.imageViewer.isShow = true;
      this.imageViewer.file = file;
    },
    sendRecorder(file) {
      this.recorder = false;
      // this.$refs.filesManager.upload(file)
      this.uploadVoice(file);
    },
    // 确认上传图片消息回调事件
    confirmUploadImage() {
      //
      let file = this.imageViewer.file;
      this.uploadImage(file);
    },
    uploadImage(file) {
      // console.log("bdinput uploadImage");
      //
      let app = this;
      this.compressImage(file, function(newFile) {
        console.log('compressImage', file)
        //
        let filename = moment(new Date()).format("YYYYMMDDHHmmss");
        if (file.type === "image/jpeg") {
          filename = filename + ".jpg";
        } else if (file.type === "image/png") {
          filename = filename + ".png";
        }
        //
        var formdata = new FormData();
        formdata.append("file_name", filename);
        formdata.append("username", app.userInfo.username);
        formdata.append("type", constants.UPLOAD_FILE_TYPE_IMAGE)
        formdata.append("file", newFile);
        formdata.append("client", "web");
        //
        let ref = app.$refs.imageViewer;
        // app.$message(app.$t('uploading'))
        $.ajax({
          url: app.uploadImageServerUrl,
          contentType: false,
          cache: false,
          processData: false,
          mimeTypes: "multipart/form-data",
          type: "post",
          data: formdata,
          success: function(response) {
            ref.loading = false;
            ref.closeBox();
            // console.log('upload response:', response.data)
            var imageUrl = response.data;
            let payload = {
              type: constants.MESSAGE_TYPE_IMAGE,
              content: imageUrl,
              thread: app.userCurrentThread,
            };
            app.sendMessageProtobuf(payload);
            // 提示
            app.$message({ message: app.$t("uploadsuccess"), type: "success" });
          },
          error: function(error) {
            ref.loading = false;
            console.log(error);
            // app.$message.error(app.$t('uploadfailed'))
            app.$notify({
              title: app.$t("tip"),
              message: app.$t("sendImageError"),
              type: "error",
            });
          },
        });
      });
    },
    compressImage(file, callback) {
      // 判断文件大小
      if (file.size > 1024 * 1024 * 1) {
        console.log("图片大于1M进行压缩");
        //
        this.canvasDataURL(file, function(blob) {
          //
          var newFile = new File([blob], file.name, {
            type: file.type,
          });
          var isLt1M;
          if (file.size < newFile.size) {
            isLt1M = file.size;
          } else {
            isLt1M = newFile.size;
          }
          console.log("file.size:" + file.size / 1024 / 1024);
          console.log("newFile.size: " + newFile.size / 1024 / 1024);
          //
          if (file.size < newFile.size) {
            callback(file);
          }
          callback(newFile);
        });
      } else {
        console.log("图片小于1M直接上传");
        //
        return callback(file);
      }
    },
    // 图片压缩方法
    canvasDataURL(file, callback) {
      console.log("canvasDataURL");
      //
      let app = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function(e) {
        const img = new Image();
        const quality = 0.1; // 图像质量
        const canvas = document.createElement("canvas");
        const drawer = canvas.getContext("2d");
        img.src = this.result;
        img.onload = function() {
          canvas.width = img.width;
          canvas.height = img.height;
          drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
          return app.convertBase64UrlToBlob(
            canvas.toDataURL("image/jpeg", quality),
            callback
          );
        };
      };
    },
    // 将以base64的图片url数据转换为Blob
    convertBase64UrlToBlob(urlData, callback) {
      console.log("convertBase64UrlToBlob");
      //
      var bytes = window.atob(urlData.split(",")[1]); //去掉url的头，并转换为byte
      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      var blob = new Blob([ab], { type: "image/jpeg" });
      callback(blob);
    },
    //
    uploadVoice(file) {
      console.log('uploadVoice:', file)
      //
      let filename = moment(new Date()).format("YYYYMMDDHHmmss") + ".wav";
      //
      var formdata = new FormData();
      formdata.append("file_name", filename);
      formdata.append("username", this.userInfo.username);
      formdata.append("type", constants.UPLOAD_FILE_TYPE_VOICE)
      formdata.append("file", file);
      formdata.append("client", 'web');
      //
      let app = this;
      $.ajax({
        url: this.uploadVoiceServerUrl,
        contentType: false,
        cache: false,
        processData: false,
        mimeTypes: "multipart/form-data",
        type: "post",
        data: formdata,
        success: function(response) {
          // console.log('upload response:', response.data)
          var voiceUrl = response.data;
          let payload = {
            type: constants.MESSAGE_TYPE_VOICE,
            content: voiceUrl,
            thread: app.userCurrentThread,
          };
          app.sendMessageProtobuf(payload);
          // 提示
          app.$message({ message: app.$t("uploadsuccess"), type: "success" });
        },
        error: function(error) {
          // ref.loading = false
          console.log(error);
          // app.$message.error(app.$t('uploadfailed'))
          app.$notify({
            title: app.$t("tip"),
            message: app.$t("sendImageError"),
            type: "error",
          });
        },
      });
    },
    initDragUpload() {
      // // 拖拽上传发送文件
      // var oDragWrap = document.body;
      // //拖进
      // oDragWrap.addEventListener(
      //   "dragenter",
      //   function(e) {
      //     e.preventDefault();
      //     // console.log('dragenter:')
      //     // console.log(e)
      //   },
      //   false
      // );
      // //拖离
      // oDragWrap.addEventListener(
      //   "dragleave",
      //   function(e) {
      //     e.preventDefault();
      //     // dragleaveHandler(e);
      //     // console.log('dragleave:')
      //     // console.log(e)
      //   },
      //   false
      // );
      // //拖来拖去 , 一定要注意dragover事件一定要清除默认事件
      // //不然会无法触发后面的drop事件
      // oDragWrap.addEventListener(
      //   "dragover",
      //   function(e) {
      //     e.preventDefault();
      //     // console.log('dragover:')
      //     // console.log(e)
      //   },
      //   false
      // );
      // //扔
      // oDragWrap.addEventListener(
      //   "drop",
      //   function(e) {
      //     dropHandler(e);
      //     // console.log('drop:')
      //     // console.log(e)
      //   },
      //   false
      // );
      // var dropHandler = function(e) {
      //   // 将本地图片拖拽到页面中后要进行的处理都在这
      //   e.preventDefault(); //获取文件列表
      //   console.log("dropHandler:");
      //   console.log(e);
      //   //
      //   var fileList = e.dataTransfer.files;
      //   // 检测是否是拖拽文件到页面的操作
      //   if (fileList.length == 0) {
      //     return;
      //   }
      //   // 检测文件是不是图片
      //   if (fileList[0].type.indexOf("image") === -1) {
      //     return;
      //   }
      //   // 上传文件，并发送
      //   let file = fileList[0];
      //   if (/\.(gif|jpg|jpeg|png|webp|GIF|JPG|PNG|WEBP)$/.test(file.name)) {
      //     // 发送图片
      //     app.uploadImage(file);
      //     return;
      //   }
      //   // 发送其他文件
      //   app.uploadFile(file);
      // };
    },
    // imgReader (item) {
    //   var file = item.getAsFile()
    //   // this.uploadImage(file)
    //   //
    //   this.imageViewer.isShow = true
    //   this.imageViewer.file = file
    // },
    // prePage () {},
    // nextPage () {
    //   let size = 20
    //   this.getMessages(size)
    // }
  },
  // directives: {
  //   focus: {
  //     inserted: function (el) {
  //       el.focus()
  //     }
  //   }
  // },
  created() {
    // 延迟发送预知消息，否则会造成太多冗余消息
    this.delaySendPreviewMessage = _.debounce(this.sendPreviewMessage, 3000);
    this.shouldShowInputTips = Vue.ls.get(constants.SHOW_INPUT_TIPS, true);
    this.shouldTranslate = Vue.ls.get(constants.SHOULD_TRANSLATE_INPUT, false);
  },
  mounted() {
    // 防止在bus回调内部无法访问this
    let app = this;
    // 点击快捷回复
    bus.$on(constants.EVENT_BUS_SELECT_CUW, (content) => {
      if (this.disabled) {
        return;
      }
      // this.inputContent += content
    });
    // 拉黑用户
    bus.$on(constants.EVENT_BUS_BLOCK_USER, (topic) => {
      // console.log('block:' + topic)
      app.blockThreadTopic = topic;
      app.isBlockFromAside = true;
      app.blockDialogVisible = true;
    });
    // 发送快捷回复
    bus.$on(constants.EVENT_BUS_SEND_CUW, (cuw) => {
      if (this.disabled) {
        return;
      }
      let type = cuw.type;
      let content = cuw.content;
      // 判断类型
      if (type && type === constants.MESSAGE_TYPE_IMAGE) {
        // 发送图片消息
        let payload = {
          type: constants.MESSAGE_TYPE_IMAGE,
          content: content,
          thread: this.userCurrentThread,
        };
        this.sendMessageProtobuf(payload);
      } else if (type && type === constants.MESSAGE_TYPE_FILE) {
        // 发送文件消息
        let payload = {
          type: constants.MESSAGE_TYPE_FILE,
          content: content,
          thread: this.userCurrentThread,
        };
        this.sendMessageProtobuf(payload);
      } else if (type && type === constants.MESSAGE_TYPE_VOICE) {
        // 发送语音消息
        let payload = {
          type: constants.MESSAGE_TYPE_VOICE,
          content: content,
          thread: this.userCurrentThread,
        };
        this.sendMessageProtobuf(payload);
      } else if (type && type === constants.MESSAGE_TYPE_VIDEO) {
        // 发送视频消息
        let payload = {
          type: constants.MESSAGE_TYPE_VIDEO,
          content: content,
          thread: this.userCurrentThread,
        };
        this.sendMessageProtobuf(payload);
      } else if (type && type === constants.MESSAGE_TYPE_CARD) {
        // 发送卡片消息
        let cardContent = JSON.stringify({
          name: cuw.name,
          content: cuw.content
        })
        console.log('cardContent: ', cardContent)
        let payload = {
          type: constants.MESSAGE_TYPE_CARD,
          content: cardContent,
          thread: this.userCurrentThread,
        };
        this.sendMessageProtobuf(payload);
      } else if (type && type === constants.MESSAGE_TYPE_CHOICE) {
        // 发送选择问题
        let choice = ''
        for (let i = 0; i < cuw.choices.length; i++) {
          const element = cuw.choices[i]
          choice += element
          if (i + 1 < cuw.choices.length) {
            choice += ','
          }
        }
        let payload = {
          type: constants.MESSAGE_TYPE_CHOICE,
          content: content,
          choices: choice,
          thread: this.userCurrentThread,
        };
        this.sendMessageChoiceProtobuf(payload);
      } else {
        // 发送文本消息
        if (content.trim().length > 500) {
          this.$notify({
            title: this.$t("tip"),
            message: this.$t("messageTooLong"),
            type: "error",
          });
          return;
        }
        if (content.trim().length > 0) {
          let payload = {
            type: constants.MESSAGE_TYPE_TEXT,
            content: content,
            thread: this.userCurrentThread,
          };
          this.sendMessageProtobuf(payload);
          this.inputContent = "";
        }
        if (this.userCurrentThread.closed) {
          this.$message.warning(this.$t("closedSendNotice"));
        }
      }
    });
    // 消息预知
    bus.$on(constants.EVENT_BUS_MESSAGE_PREVIEW, (message) => {
      // console.log('preview:', message.content)
      if (message.thread.tid === this.userCurrentThread.tid) {
        if (message.content.trim().length > 0) {
          app.inputTipVisible = true;
          this.previewContent = app.inputing + message.content;
          // if (this.previewContent.length > 15) {
          //   this.previewContent = this.previewContent.substring(0, 12) + '...'
          // }
        } else {
          this.previewContent = "";
          app.inputTipVisible = false;
        }
        // 5s 定期清空状态
        setTimeout(function() {
          app.inputTipVisible = false;
        }, 6000);
      }
    });
    //
    // document.getElementById('myInput').addEventListener('paste', function( e ){
    //   // 添加到事件对象中的访问系统剪贴板的接口
    //   var clipboardData = e.clipboardData,
    //     i = 0,
    //     items, item, types;
    //   if (clipboardData) {
    //     items = clipboardData.items;
    //     if( !items ){
    //       return
    //     }
    //     item = items[0];
    //     // 保存在剪贴板中的数据类型
    //     types = clipboardData.types || [];
    //     for( ; i < types.length; i++ ){
    //       if( types[i] === 'Files' ){
    //         item = items[i]
    //         break
    //       }
    //     }
    //     // 判断是否为图片数据
    //     if( item && item.kind === 'file' && item.type.match(/^image\//i) ){
    //       app.imgReader(item)
    //     }
    //   }
    // })
  },
  beforeDestroy() {
    bus.$off(constants.EVENT_BUS_SELECT_CUW);
    bus.$off(constants.EVENT_BUS_BLOCK_USER);
    bus.$off(constants.EVENT_BUS_SEND_CUW);
    bus.$off(constants.EVENT_BUS_MESSAGE_PREVIEW);
  },
};
</script>

<style scoped>
#bd-input {
  width: 100%;
  height: 100%;
  /* height: 130px; */
  background: #fff;
  border-top: solid 0.1px #dddddd;
}
#bd-emoji {
  float: left;
  margin-top: 7px;
  margin-left: 20px;
  cursor: pointer;
  list-style: none;
}
.bd-emoji-box {
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  margin-top: -295px;
  width: 280px;
  height: 280px;
  padding: 3px 6px 6px 14px;
  background-color: #fff;
  border: 1px solid #d1d1d1;
  border-radius: 2px;
  box-shadow: 0 1px 2px 1px #d1d1d1;
}
.bd-emoji-box li {
  list-style: none;
  width: 24px;
  margin-top: 15px;
  margin-left: 5px;
  border: none;
  margin-bottom: 0px;
}
.bd-emoji-box.showbox-enter-active,
.bd-emoji-box.showbox-leave-active {
  transition: all 0.5s;
}
.bd-emoji-box.showbox-enter,
.bd-emoji-box.showbox-leave-active {
  opacity: 0;
}
.bd-input-tip {
  position: absolute;
  bottom: 172px;
  width: 500px;
  padding: 3px 6px 6px 10px;
  background-color: #fff;
  border: 1px solid #d1d1d1;
  text-align: left;
}
.bd-input-tip li {
  list-style: none;
  margin-top: 5px;
  border: none;
  cursor: pointer;
}
.bd-input-tip.showbox-enter-active,
.bd-input-tip.showbox-leave-active {
  transition: all 0.5s;
}
.bd-input-tip.showbox-enter,
.bd-input-tip.showbox-leave-active {
  opacity: 0;
}
#bd-microphone {
  float: left;
  margin-top: 8px;
  margin-left: 18px;
  color: gray;
  cursor: pointer;
  list-style: none;
  font-size: 16px;
}
.bd-upload-image {
  margin-top: 8px;
  color: gray;
  margin-left: 20px;
  cursor: pointer;
  float: left;
  list-style: none;
  font-size: 16px;
}
.bd-upload-file {
  margin-top: 6px;
  font-size: 16px;
  color: gray;
  margin-left: 20px;
  cursor: pointer;
  float: left;
  list-style: none;
  font-size: 16px;
}
#bd-file-manager {
  float: left;
  margin-top: 8px;
  margin-left: 20px;
  color: gray;
  cursor: pointer;
  list-style: none;
  font-size: 16px;
}
#bd-rate {
  float: left;
  margin-top: 7px;
  margin-left: 18px;
  color: gray;
  cursor: pointer;
  list-style: none;
  font-size: 14px;
}
#bd-jietu {
  float: left;
  margin-top: 7px;
  margin-left: 16px;
  cursor: pointer;
  list-style: none;
  font-size: 16px;
}
#bd-video {
  float: left;
  margin-top: 2px;
  margin-left: 20px;
  cursor: pointer;
  list-style: none;
  font-size: 20px;
}
#bd-rtcvideo {
  float: left;
  margin-top: 6px;
  margin-left: 20px;
  cursor: pointer;
  list-style: none;
  font-size: 18px;
}
#bd-phone {
  float: left;
  margin-top: 6px;
  margin-left: 15px;
  cursor: pointer;
  list-style: none;
  font-size: 20px;
}
#bd-block {
  float: left;
  margin-top: 6px;
  margin-left: 15px;
  cursor: pointer;
  list-style: none;
  font-size: 19px;
}
#bd-form {
  float: left;
  margin-top: 7px;
  margin-left: 15px;
  cursor: pointer;
  list-style: none;
  font-size: 16px;
}
#bd-history {
  float: right;
  margin-top: 7px;
  margin-right: 15px;
  cursor: pointer;
  list-style: none;
  font-size: 16px;
}
#bd-rich {
  float: right;
  margin-top: 7px;
  margin-right: 15px;
  cursor: pointer;
  list-style: none;
  font-size: 16px;
}
#bd-tip {
  float: left;
  margin-top: 9px;
  margin-left: 15px;
  cursor: pointer;
  list-style: none;
  font-size: 10px;
  /* display: inline-block; */
  /* width: 400px; */
  height: calc(100% - 200px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.sendbutton {
  /* position: absolute;
  bottom: 35px;
  right: 3%; */
  position: relative;
  bottom: 65px;
  right: -150px;
}
/* .emoji-invoker {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
  padding: 0;
  background: transparent;
  border: 0;
}
.emoji-invoker:hover {
  transform: scale(1.1);
}
.emoji-invoker > svg {
  fill: #b1c6d0;
}
.emoji-picker {
  position: absolute;
  z-index: 1;
  font-family: Montserrat;
  border: 1px solid #ccc;
  width: 15rem;
  height: 20rem;
  overflow: scroll;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 1px 1px 8px #c7dbe6;
}
.emoji-picker__search {
  display: flex;
}
.emoji-picker__search > input {
  flex: 1;
  border-radius: 10rem;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  outline: none;
}
.emoji-picker h5 {
  margin-bottom: 0;
  color: #b1b1b1;
  text-transform: uppercase;
  font-size: 0.8rem;
  cursor: default;
}
.emoji-picker .emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.emoji-picker .emojis:after {
  content: "";
  flex: auto;
}
.emoji-picker .emojis span {
  padding: 0.2rem;
  cursor: pointer;
  border-radius: 5px;
}
.emoji-picker .emojis span:hover {
  background: #ececec;
  cursor: pointer;
} */
</style>
